import { render } from "./CInputCheckbox.vue?vue&type=template&id=b93384ac"
import script from "./CInputCheckbox.vue?vue&type=script&lang=js"
export * from "./CInputCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__